import { BoxItem } from 'box-ui-elements/es';
import { compact } from 'lodash';
import { BoxTemplateLabels, FileType, QuoteStatus } from 'enums';
import { ExtendedMarketRequest, Quote } from 'types';
import { getFileMetadataField } from 'utils';
import { ExtendedBoxItem } from 'broker/components/FilesExplorer/types';

export const quoteFilesTypes = [FileType.MarketQuote, FileType.RenewalPolicy];

interface ActiveQuoteConfig {
  isActive: boolean;
}

export function getActiveQuotes(quotes: Quote[]): Quote[] {
  const activeQuoteConfig: Record<QuoteStatus, ActiveQuoteConfig> = {
    [QuoteStatus.Quoting]: { isActive: true },
    [QuoteStatus.Selected]: { isActive: true },
    [QuoteStatus.Rejected]: { isActive: false },
    [QuoteStatus.Processing]: { isActive: false },
  };

  return quotes.filter((quote) => activeQuoteConfig[quote.status].isActive);
}

export function getSubjectivitiesFromQuotes(marketRequests: ExtendedMarketRequest[], attachedFiles: BoxItem[]): string {
  const marketRequestsWithQuotes = marketRequests.filter((marketRequest) => marketRequest.quote);
  const subjectivitiesContent = compact(
    attachedFiles.map((attachedFile) => {
      const marketRequestFromAttachedFile = marketRequestsWithQuotes.find((marketRequest) =>
        marketRequest.quote?.capitolaQuoteFileIds.includes(attachedFile.id),
      );
      if (!marketRequestFromAttachedFile?.quote?.subjectivities?.carrierSpecific) {
        return null;
      }
      return `${marketRequestFromAttachedFile?.market.marketName}:<br>
      ${marketRequestFromAttachedFile?.quote?.subjectivities.carrierSpecific}`;
    }),
  );
  if (subjectivitiesContent.length === 0) {
    return '';
  }
  return subjectivitiesContent.join('<br><br>');
}

export function getFileForQuoteExtraction(quoteFiles: ExtendedBoxItem[]): ExtendedBoxItem | undefined {
  return quoteFiles.find((file) => {
    const fileType = getFileMetadataField(file, BoxTemplateLabels.FileType);
    return quoteFilesTypes.includes(fileType) && !!file.syncMetadata?.extractedData;
  });
}
